import { ListingExtendedInfo } from '../../external'

export interface ExtendedColumnConfigProps {
  header: JSX.Element
  columnKey: string
  groupId?: string
  width: number
  renderer: (home?: ListingExtendedInfo) => JSX.Element
}

export interface ExtendedColumnHeaderProps extends ExtendedColumnConfigProps {
  groundHeaders?: JSX.Element[]
  groupLabel?: JSX.Element
}

export enum FastTapeChartExtendedColumnKey {
  revenueModel = 'revenueModel',
  status = 'status',
  cleanStatus = 'cleanStatus',
  inspectStatus = 'inspectStatus',
  casesStatus = 'casesStatus',
  attentionBadges = 'operationTags',
  note = 'note',
}
